/* The Written Hug: required-field guard for Add to Cart.
   WHY: Horizon's add-to-cart click handler runs form.checkValidity() and simply
   returns when a required field (recipient name, street, city, state, ZIP, or
   the message) is empty. The browser's own bubble is brief, absent on Safari and
   most phones, and impossible when the field sits in a hidden composer stage
   (the sticky bar's puppet click). To the shopper the button is dead.
   HOW: capture-phase veto on the add buttons and the form submit. When the form
   is invalid: move the composer to the stage holding the first empty field,
   mark every empty field with an inline message, scroll the first one into
   view and focus it. When the form is valid: do nothing, Horizon proceeds.
   Loads LAST (after twh-cap-guard.js) and no-ops if the composer is absent. */
(function(){
  if(window.TWH_REQ_GUARD) return;
  var COPY={
    'twh-message':'Add the message you want us to write inside the card.',
    'twh-dl-name':"Add the recipient's name.",
    'twh-dl-addr':'Add the street address we should mail it to.',
    'twh-dl-city':'Add the city.',
    'twh-dl-state':'Pick the state.',
    'twh-dl-zip':'Add the 5-digit ZIP.'
  };
  function summary(bad){
    var addr=false,msg=false,other=false;
    for(var i=0;i<bad.length;i++){
      var id=bad[i].id||'';
      if(id.indexOf('twh-dl-')===0) addr=true; else if(id==='twh-message') msg=true; else other=true;
    }
    if(addr&&msg) return "We need your message and the recipient's address before we can mail it.";
    if(addr) return "We need the recipient's address before we can mail it.";
    if(msg) return 'We need your message before we can write the card.';
    return 'A few details are missing before we can add this to your cart.';
  }
  var css='.twh-req-invalid{border-color:#b42318!important;box-shadow:0 0 0 2px rgba(180,35,24,.18)!important}'
    +'.twh-req-err{color:#b42318;font-size:.85rem;line-height:1.35;margin:.35rem 0 0;font-weight:600}'
    +'.twh-req-banner{color:#b42318;background:rgba(180,35,24,.07);border:1px solid rgba(180,35,24,.35);border-radius:.5rem;padding:.6rem .8rem;margin:0 0 .75rem;font-size:.9rem;font-weight:600}'
    +'.twh-req-banner a{color:inherit;text-decoration:underline;cursor:pointer}';
  function getForm(){
    var pf=document.querySelector('product-form-component form');
    return pf||document.querySelector('form[id^="BuyButtons-ProductForm"]');
  }
  function fieldMsg(el){
    if(el.validity&&el.validity.customError&&el.validationMessage) return el.validationMessage;
    if(COPY[el.id]) return COPY[el.id];
    if(el.validity&&el.validity.patternMismatch&&el.title) return el.title;
    return el.validationMessage||'This field is required.';
  }
  function invalids(form){
    var out=[],els=form.elements;
    for(var i=0;i<els.length;i++){
      var el=els[i];
      if(!el||el.disabled||el.type==='hidden'||!el.validity) continue;
      if(el.validity.valid) continue;
      if(el.type==='submit'||el.type==='button') continue;
      out.push(el);
    }
    return out;
  }
  function errNode(el){
    var id=el.id||('twh-req-'+Math.random().toString(36).slice(2));
    el.id=id;
    var eid=id+'-req-err',n=document.getElementById(eid);
    if(!n){
      n=document.createElement('p');n.className='twh-req-err';n.id=eid;n.setAttribute('role','alert');
      var host=(el.type==='radio'||el.type==='checkbox')?el.closest('fieldset,label')||el:el;
      host.insertAdjacentElement('afterend',n);
    }
    return n;
  }
  function mark(el){
    el.classList.add('twh-req-invalid');el.setAttribute('aria-invalid','true');
    var n=errNode(el);n.textContent=fieldMsg(el);el.setAttribute('aria-describedby',n.id);
    if(!el.__twhReq){
      el.__twhReq=true;
      var clear=function(){ if(el.validity&&el.validity.valid){unmark(el);banner(false);} else {var m=document.getElementById(el.id+'-req-err'); if(m) m.textContent=fieldMsg(el);} };
      el.addEventListener('input',clear);el.addEventListener('change',clear);el.addEventListener('blur',clear);
    }
  }
  function unmark(el){
    el.classList.remove('twh-req-invalid');el.removeAttribute('aria-invalid');
    var n=document.getElementById(el.id+'-req-err'); if(n) n.remove();
  }
  function banner(on,first,bad){
    var form=getForm(); if(!form) return;
    var b=form.querySelector('.twh-req-banner');
    if(!on){ if(b) b.remove(); return; }
    if(!b){ b=document.createElement('div');b.className='twh-req-banner';b.setAttribute('role','alert');form.insertAdjacentElement('afterbegin',b); }
    b.textContent='';
    b.appendChild(document.createTextNode(summary(bad||[])+' '));
    if(first){
      var a=document.createElement('a');a.textContent='Show me';a.href='#'+first.id;
      a.addEventListener('click',function(e){e.preventDefault();reveal(first);});
      b.appendChild(a);
    }
  }
  /* Composer stages: the buy block lives in stage 3, the message in stage 2. A
     field in a stage that is not current is display:none, so it cannot be
     focused. Walk forward with the composer's own Next buttons, which also run
     its own gate (an empty message stops the walk at stage 2, which is right). */
  function showStage(el){
    var root=document.querySelector('.twh-composer'), panel=el.closest('[data-twh-stage]');
    if(!root||!panel) return;
    var want=parseInt(panel.getAttribute('data-twh-stage'),10);
    var guard=0;
    while(guard++<4){
      var cur=parseInt(root.getAttribute('data-twh-step')||'1',10);
      if(cur===want||isNaN(cur)) return;
      var btn=cur<want?root.querySelector('[data-twh-next="'+(cur+1)+'"]'):root.querySelector('[data-twh-go="'+want+'"]');
      if(!btn||btn.disabled) return;
      btn.click();
      if(parseInt(root.getAttribute('data-twh-step')||'1',10)===cur) return;
    }
  }
  function reveal(el){
    showStage(el);
    try{ el.scrollIntoView({behavior:'smooth',block:'center'}); }catch(e){ try{el.scrollIntoView();}catch(e2){} }
    setTimeout(function(){ try{ el.focus({preventScroll:true}); }catch(e){ try{el.focus();}catch(e2){} } },350);
  }
  function gate(e){
    var form=getForm(); if(!form) return true;
    var bad=invalids(form);
    if(!bad.length){ banner(false); return true; }
    if(e){ e.preventDefault(); e.stopImmediatePropagation(); }
    for(var i=0;i<bad.length;i++) mark(bad[i]);
    banner(true,bad[0],bad);
    reveal(bad[0]);
    return false;
  }
  function isAddButton(t){
    if(!t||!t.closest) return null;
    return t.closest('button[name="add"],.add-to-cart-button,.sticky-add-to-cart__button');
  }
  function init(){
    if(!document.getElementById('twh-message')&&!document.querySelector('.twh-personalize')) return;
    var s=document.createElement('style');s.textContent=css;document.head.appendChild(s);
    document.addEventListener('click',function(e){
      var b=isAddButton(e.target); if(!b) return;
      var form=getForm(); if(!form) return;
      if(b.form&&b.form!==form) return; /* another product's form, e.g. quick add */
      gate(e);
    },true);
    document.addEventListener('submit',function(e){
      var form=getForm(); if(!form||e.target!==form) return;
      gate(e);
    },true);
    /* Enter inside a text field submits the form; the submit hook above covers
       it. Also clear a stale banner once everything is filled in. */
    document.addEventListener('input',function(){
      var form=getForm(); if(form&&form.querySelector('.twh-req-banner')&&!invalids(form).length) banner(false);
    },true);
    window.TWH_REQ_GUARD={check:function(){return gate(null);}};
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
